// The height of the search bar, which is actually the command palette trigger button.
// This is used to ensure the page factors in the height of the search bar and ensure content inside is scrollable.
export const SEARCH_BAR_HEIGHT = 44;

// The height of the User and Role page headers - i.e. the page title, description, divider, and search bar (that sits just above the table).
// Used to ensure that the object list doesn't exceed the page height, and allows the content inside the object list to be scrollable.
export const TABLE_HEADER_HEIGHT = 194;
